// Enhanced logger with enable/disable toggle, dynamic level changes, and async timing helper.
import { env } from '../utils/env';
const levelOrder = ['debug', 'info', 'warn', 'error', 'silent'];
function shouldLog(level) {
    const current = env.LOG_LEVEL || 'info';
    return levelOrder.indexOf(level) >= levelOrder.indexOf(current);
}
function baseLog(level, msg, data) {
    if (!shouldLog(level))
        return;
    const prefix = `[${env.APP_DISPLAY_NAME}][${level.toUpperCase()}]`;
    const method = level === 'debug' ? 'log' : level;
    // eslint-disable-next-line no-console
    const args = data !== undefined ? [prefix, msg, data] : [prefix, msg];
    console[method](...args);
}
export const logger = {
    debug: (msg, data) => baseLog('debug', msg, data),
    info: (msg, data) => baseLog('info', msg, data),
    warn: (msg, data) => baseLog('warn', msg, data),
    error: (msg, data) => baseLog('error', msg, data),
    time(label) {
        if (!shouldLog('debug'))
            return;
        console.time(label);
    },
    timeEnd(label) {
        if (!shouldLog('debug'))
            return;
        console.timeEnd(label);
    },
    measure(label, fn) {
        this.time(label);
        try {
            return fn();
        }
        finally {
            this.timeEnd(label);
        }
    }
};
export default logger;
